import { Lang } from "@/lang/lang";
export default [
  {
    label: Lang.label.empIcon,
    list: [  
      'icon-heroicons2',
      'icon-luyouqi',
      'icon-server',
      'icon-icon-Line-Search22',
      'icon-heroicons1',
      'icon-icon-but_11',
      'icon-position',
      'icon-heroicons',
      'icon-heroicons-2',
      'icon-a-Component797',
      'icon-download',
      'icon-icon-but_10',
      'icon-icon-but_07',
      'icon-icon-but_09',
      'icon-icon-but_08',
      'icon-icon-but_04',
      'icon-icon-but_03',
      'icon-icon-but_02',
      'icon-icon-but_01',
      'icon-menu2_011',
      'icon-menu2_022',
      'icon-menu2_08',
      'icon-menu2_072',
      'icon-menu2_041',
      'icon-menu2_061',
      'icon-menu2_051',
      'icon-menu2_032',
      'icon-Tips',
      'icon-menu1_esg_nor',
      'icon-menu_building',
      'icon-gf_gf_02_x',
      'icon-gf_wd_05_x',
      'icon-gf_Filled_04_x',
      'icon-gf_uv_06_x',
      'icon-gf_sz_01_x',
      'icon-gf_sj_07_x',
      'icon-gf_riqi_03_x',
      'icon-fenlei',
      'icon-menu-dot',
      'icon-a-directorytree_03_below',
      'icon-a-directorytree_03_right',
      'icon-a-directorytree_01_network-alt',
      'icon-a-directorytree_02_folder1',
      'icon-a-directorytree_02_folder',
      'icon-list_2_search',
      'icon-list_1_refresh',
      'icon-menu_device',
      'icon-menu_setting',
      'icon-menu1_01_pz',
      'icon-menu1_05_gf',
      'icon-menu_billing',
      'icon-menu1_06_hj',
      'icon-menu_energy',
      'icon-menu2_171',
      'icon-menu2_012',
      'icon-menu2_11',
      'icon-menu2_13',
      'icon-menu2_10',
      'icon-menu2_09',
      'icon-menu2_081',
      'icon-menu2_071',
      'icon-menu2_05',
      'icon-menu2_12',
      'icon-menu2_06',
      'icon-menu2_04',
      'icon-menu2_031',
      'icon-menu2_021',
      'icon-menu2_16',
      'icon-menu2_18',
      'icon-menu2_14',
      'icon-menu2_15',
      'icon-Search',
      'icon-menu1_05',
      'icon-menu1_03',
      'icon-menu1_06',
      'icon-menu1_02',
      'icon-menu1_01',
      'icon-menu2_07',
      'icon-menu2_03',
      'icon-menu2_02',
      'icon-menu2_01',
      'icon-shuaxin',
      'icon-a-Component732',
      'icon-icon-shezhi',
      'icon-up',
      'icon-do',
      'icon-Union',
      'icon-huanjing',
      'icon-dianneng',
      'icon-chuneng',
      'icon-zhangdan',
      'icon-User',
      'icon-Users',
      'icon-Shield',
      'icon-ex',
      'icon-adjustments',
      'icon-add',
      'icon-a-tubiao11',
      'icon-a-tubiao1-2',
      'icon-EDITOR',
      'icon-a-Frame1321316791',
      'icon-a-tubiao1-4',
      'icon-a-24-1',
      'icon-cipher',
      'icon-down1',
      'icon-Up1',
      'icon-a-24',
      'icon-a-Verificationcode1',
      'icon-tenantry',
      'icon-a-tubiao1-1',
      'icon-view',
      'icon-tenement',
      'icon-a-Property1guangfu21',
      'icon-a-Property1nengyuan-011',
      'icon-filter',
      'icon-a-Component6871',
      'icon-search',
      'icon-a-tubiao1',
      'icon-a-Property1nengyuan1',
      'icon-a-Property1zhongxinjifei1',
      'icon-eye-empty',
      'icon-nor',
      'icon-delete',
      'icon-left1',
      'icon-right1',
      'icon-Download',
      'icon-right',
      'icon-a-Property1zhongxinjifei',
      'icon-left',
      'icon-Up',
      'icon-a-Verificationcode',
      'icon-down',
    ],
  },
  {
    label: Lang.label.commonIcon,
    list: [
      'iconfont iconicon_roundadd',
      'iconfont iconicon_compile',
      'iconfont iconicon_glass',
      'iconfont iconicon_roundclose',
      'iconfont iconicon_roundreduce',
      'iconfont iconicon_delete',
      'iconfont iconicon_shakehands',
      'iconfont iconicon_task_done',
      'iconfont iconicon_voipphone',
      'iconfont iconicon_safety',
      'iconfont iconicon_work',
      'iconfont iconicon_study',
      'iconfont iconicon_task',
      'iconfont iconicon_subordinate',
      'iconfont iconicon_star',
      'iconfont iconicon_setting',
      'iconfont iconicon_sms',
      'iconfont iconicon_share',
      'iconfont iconicon_secret',
      'iconfont iconicon_scan_namecard',
      'iconfont iconicon_principal',
      'iconfont iconicon_group',
      'iconfont iconicon_send',
      'iconfont iconicon_scan',
      'iconfont iconicon_search',
      'iconfont iconicon_refresh',
      'iconfont iconicon_savememo',
      'iconfont iconicon_QRcode',
      'iconfont iconicon_im_keyboard',
      'iconfont iconicon_redpacket',
      'iconfont iconicon_photo',
      'iconfont iconicon_qq',
      'iconfont iconicon_wechat',
      'iconfont iconicon_phone',
      'iconfont iconicon_namecard',
      'iconfont iconicon_notice',
      'iconfont iconicon_next_arrow',
      'iconfont iconicon_left',
      'iconfont iconicon_more',
      'iconfont iconicon_details',
      'iconfont iconicon_message',
      'iconfont iconicon_mobilephone',
      'iconfont iconicon_im_voice',
      'iconfont iconicon_GPS',
      'iconfont iconicon_ding',
      'iconfont iconicon_exchange',
      'iconfont iconicon_cspace',
      'iconfont iconicon_doc',
      'iconfont iconicon_dispose',
      'iconfont iconicon_discovery',
      'iconfont iconicon_community_line',
      'iconfont iconicon_cloud_history',
      'iconfont iconicon_coinpurse_line',
      'iconfont iconicon_airplay',
      'iconfont iconicon_at',
      'iconfont iconicon_addressbook',
      'iconfont iconicon_boss',
      'iconfont iconicon_addperson',
      'iconfont iconicon_affiliations_li',
      'iconfont iconicon_addmessage',
      'iconfont iconicon_addresslist',
      'iconfont iconicon_add',
      'iconfont icongithub',
      'iconfont icongitee2',
    ],
  },
  {
    label: Lang.label.systemIcon,
    list: [
      'iconfont icon-zhongyingwen',
      'iconfont icon-caidan',
      'iconfont icon-rizhi1',
      'iconfont icon-zhuti',
      'iconfont icon-suoping',
      'iconfont icon-bug',
      'iconfont icon-qq1',
      'iconfont icon-weixin1',
      'iconfont icon-shouji',
      'iconfont icon-mima',
      'iconfont icon-yonghu',
      'iconfont icon-yanzhengma',
      'iconfont icon-canshu',
      'iconfont icon-dongtai',
      'iconfont icon-iconset0265',
      'iconfont icon-shujuzhanshi2',
      'iconfont icon-tuichuquanping',
      'iconfont icon-rizhi',
      'iconfont icon-cuowutishitubiao',
      'iconfont icon-debug',
      'iconfont icon-iconset0216',
      'iconfont icon-quanxian',
      'iconfont icon-quanxian',
      'iconfont icon-shuaxin',
      'iconfont icon-bofangqi-suoping',
      'iconfont icon-quanping',
      'iconfont icon-navicon',
      'iconfont icon-biaodan',
      'iconfont icon-liuliangyunpingtaitubiao08',
      'iconfont icon-caidanguanli',
      'iconfont icon-cuowu',
      'iconfont icon-wxbgongju',
      'iconfont icon-tuichu',
      'iconfont icon-daohanglanmoshi02',
      'iconfont icon-changyonglogo27',
      'iconfont icon-biaoge',
      'iconfont icon-baidu1',
      'iconfont icon-tubiao',
      'iconfont icon-souhu',
      'iconfont icon-msnui-360',
      'iconfont icon-iframe',
      'iconfont icon-huanyingye',
    ],
  },
];
